import { componentFactory } from 'vue-tsx-support';

import { injectStylesMixin } from '../../../mixins/inject-styles';
import { JtnUiTypography } from '../../jtn-ui-typography';

import styles from './jtn-ui-success-message.styles.scss?module';

export default componentFactory.mixin(injectStylesMixin(styles)).create({
  name: 'JtnUiSuccessMessage',
  props: {
    iconSize: {
      type: Number,
      default: 60
    },
    text: {
      type: String,
      default: 'Спасибо, сообщение отправлено'
    },
    notice: {
      type: String,
      default: ''
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    stylesWrap() {
      if (this.type !== 'absolute') {
        return '';
      }
      const windowWidth = window.innerWidth;
      const padding =
        this.isMobile || windowWidth < 600 ? '0px' : `${this.iconSize + 20}px`;
      return {
        ['padding-left']: padding,
        ['min-height']: `${this.iconSize}px`
      };
    }
  },
  render() {
    return (
      <div class={[styles.successMessage, styles[this.type]]} style={this.stylesWrap}>
        <svg class={styles.icon} width={this.iconSize} height={this.iconSize}>
          <use xlinkHref="/dist/legacy/svg-sprites/jtn-common.f7875ac1d2b1e964bfa6c21ef5757c8a.svg#jtn-common-success"></use>
        </svg>

        <JtnUiTypography class={styles.text} tag="h4" linkType="link-blue">
          {this.text}
        </JtnUiTypography>

        {this.notice.length > 0 ? (
          <JtnUiTypography class={styles.notice} tag="p" linkType="link-blue">
            {this.notice}
          </JtnUiTypography>
        ) : null}
      </div>
    );
  }
});
